<script>
import { computed } from 'vue';

import {
  LpCard,
  LpDivider,
  LpMarkerBtn,
} from '@thehotelsnetwork/lampo';

export default {
  components: {
    LpCard,
    LpDivider,
    LpMarkerBtn,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['click'],
  setup(props, { emit }) {
    const handleClick = (item) => {
      emit('click', item);
      if (item.action) {
        item.action.call(this, item.data);
      }
    };
    const notHiddenOptions = computed(() => props.options.filter((option) => !option.hidden));
    return {
      handleClick,
      notHiddenOptions,
    };
  },
};
</script>

<template>
  <LpCard
    rounded-size="big"
    class="z-10 flex flex-col gap-1 p-2 bg-white"
  >
    <div
      v-for="(item, idx) in notHiddenOptions"
      :key="idx"
    >
      <LpDivider
        v-if="item.type === 'divider'"
        data-testid="divider"
      />
      <LpMarkerBtn
        v-else
        data-testid="optionBtn"
        :color="item.class"
        tag="button"
        type="button"
        :active="item.active"
        class="w-full px-6 text-sm leading-3 text-left"
        @click="handleClick(item)"
      >
        {{ $t(item.label) }}
      </LpMarkerBtn>
    </div>
  </LpCard>
</template>

<style lang="postcss" scoped>
.options-list {
  @apply z-10 inline-block bg-white rounded-md shadow-bm;
  min-width: 8rem;
}
.options-list .divider {
  @apply my-1 border-t border-base-400;
}
.options-list .option {
  @apply my-1 text-sm font-medium leading-3 hover:cursor-pointer;
}
.options-list .option.option--default {
  @apply text-base-900 hover:bg-opacity-50 hover:bg-primary-300 hover:text-primary-500;
}
.options-list .option.option--danger {
  @apply text-danger-500 hover:bg-opacity-50 hover:bg-danger-300;
}
</style>
